<template>
  <v-layout v-if="not_show" fill-height="" justify-center="" align-center="" class="pb-10">
      <div class="ma-10">
      <v-progress-circular 
          :size="80"
          :width="10" 
          color="primary"
          indeterminate=""
          > 
          </v-progress-circular> 
      </div> 
  </v-layout>   
</template>

<script>
export default {
  props:["not","not_show"],
  data: () => ({
    
  }),
  computed: {
     
  },  
  methods: {
     
  },
};
</script>
